export const sum = (numbers: number[]) => {
  if (numbers.length === 0) return 0;
  return numbers.reduce((a, b) => a + b);
};

export const unique = <T>(list: T[]) => [...new Set(list)];

export const sortDate = (a: Date, b: Date) => b.getTime() - a.getTime();

/**
 * Splits the original collection into pair of lists,
 * where first list contains elements for which predicate yielded true,
 * while second list contains elements for which predicate yielded false.
 * @param list
 * @param filter
 */
export const partition = <T>(list: T[], predicate: (element: T) => boolean) => {
  const [filtered, unfiltered]: [T[], T[]] = [[], []];
  list.forEach((it) => (predicate(it) ? filtered : unfiltered).push(it));
  return [filtered, unfiltered];
};

// Items must be comparable
export const intersect = <T>(a: T[], b: T[]) =>
  a.filter((it) => b.includes(it));

export const sort = <T, K>(list: T[], comparator: (item: T) => K): T[] =>
  list.sort((a, b) => {
    const aVal = comparator(a);
    const bVal = comparator(b);
    if (aVal < bVal) return -1;
    if (aVal > bVal) return 1;
    return 0;
  });

// E.g. range(5) gives [0,1,2,3,4]
export const range = (n: number) => Array.from(Array(n)).map((_, i) => i);

export const mapValues = <T>(obj: T, fn: (value: any) => any): T =>
  Object.fromEntries(
    Object.entries(obj as any).map(([key, value]) => [key, fn(value)]),
  ) as T;
